module.exports = __webpack_public_path__ + "assets/img/icons8-great-britain-144.5abc87eb.png";